import React from "react";
import PropTypes from "prop-types";
import { detect } from "detect-browser";
import ActionsIEForm from "./InternetExplorer/ActionsIEForm";
import CandidateActions from "./CandidateActions";
import { MessageFormWrapper } from "./styles/message-form-styles";

const MessageForm = (props) => {
  const isIe = detect().name === "ie";
  const {
    updateStatusLink,
    updateCandidateStatus,
    toggleActionsDropdown,
    actionsDropdown,
    offerMade,
    jobFilled,
    isEmployer,
    isRejected,
    jobCurrencySymbol,
    jobStatus,
  } = props;

  return (
    <MessageFormWrapper>
      {isIe ? (
        <ActionsIEForm
          updateStatusLink={updateStatusLink}
          offerMade={offerMade}
          isEmployer={isEmployer}
        />
      ) : (
        <CandidateActions
          updateCandidateStatus={updateCandidateStatus}
          toggleActionsDropdown={toggleActionsDropdown}
          actionsDropdown={actionsDropdown}
          offerMade={offerMade}
          jobFilled={jobFilled}
          isEmployer={isEmployer}
          isRejected={isRejected}
          jobCurrencySymbol={jobCurrencySymbol}
          jobStatus={jobStatus}
        />
      )}
    </MessageFormWrapper>
  );
};

MessageForm.propTypes = {
  actionsDropdown: PropTypes.bool.isRequired,
  isEmployer: PropTypes.bool.isRequired,
  updateStatusLink: PropTypes.string,
  updateCandidateStatus: PropTypes.func.isRequired,
  toggleActionsDropdown: PropTypes.func.isRequired,
  jobCurrencySymbol: PropTypes.string.isRequired,
  jobStatus: PropTypes.string.isRequired,
  isRejected: PropTypes.bool.isRequired,
  jobFilled: PropTypes.bool,
  offerMade: PropTypes.bool.isRequired,
};

MessageForm.defaultProps = {
  jobFilled: PropTypes.isNull,
  updateStatusLink: PropTypes.isNull,
};

export default MessageForm;
